"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.MINIMISED_MENU = exports.MENU_CONTAINER = exports.MENU = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var MENU_TRANSITION = {
  transition: "width .3s ease-in-out, min-width .3s ease-in-out"
},
    MENU = function MENU(a, b, c) {
  var d,
      e = 4 < arguments.length && arguments[4] !== void 0 ? arguments[4] : {},
      f = e.hideBorder;
  return (0, _cxs["default"])(_objectSpread(_objectSpread((d = {
    background: a ? _vars.FLATTENED_COLOURS[a] : _vars.COLOURS.mono.white
  }, (0, _defineProperty2["default"])(d, "left" === b ? "borderRight" : "borderLeft", f ? void 0 : "1px solid ".concat(_vars.COLOURS.grey.mischka.russian)), (0, _defineProperty2["default"])(d, "height", "100%"), (0, _defineProperty2["default"])(d, "display", "flex"), (0, _defineProperty2["default"])(d, "flexDirection", "column"), (0, _defineProperty2["default"])(d, "position", "fixed"), (0, _defineProperty2["default"])(d, "boxSizing", "border-box"), d), MENU_TRANSITION), {}, {
    width: "".concat(c, "px")
  }));
};

exports.MENU = MENU;

var MENU_CONTAINER = function MENU_CONTAINER(a) {
  var b = a.width;
  return (0, _cxs["default"])(_objectSpread({
    height: "100%",
    width: "".concat(b, "px"),
    minWidth: "".concat(b, "px"),
    ":focus": {
      outline: "1px solid",
      outlineColor: "inherit"
    }
  }, MENU_TRANSITION));
};

exports.MENU_CONTAINER = MENU_CONTAINER;

var MINIMISED_MENU = function MINIMISED_MENU(a) {
  var b = a.minimisedWidth;
  return (0, _cxs["default"])({
    width: "".concat(b, "px !important"),
    minWidth: "".concat(b, "px !important")
  });
};

exports.MINIMISED_MENU = MINIMISED_MENU;